import { createFeatureSelector } from '@ngrx/store';
import { CommonState } from './reducers';


export const SelectSharedState = createFeatureSelector<CommonState>('SharedModuleState');